/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type SoftwareNotificationsSettingsType from '@jira/spa-apps__project-settings-software-notifications/src/ProjectSettingsSoftwareNotifications.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazySoftwareNotificationsSettings: LazyComponent<
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	React.ComponentType<Record<any, any>>
> = lazyForPaint<typeof SoftwareNotificationsSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-software-notifications", jiraSpaEntry: "async-project-settings-software-notifications" */ '@jira/spa-apps__project-settings-software-notifications/src/ProjectSettingsSoftwareNotifications.tsx'
		),
	),
);

const AsyncSoftwareNotificationsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazySoftwareNotificationsSettings}
		pageId="project-settings-software-notifications"
		shouldShowSpinner={false}
	/>
);

export default AsyncSoftwareNotificationsSettings;
